module.exports = __webpack_public_path__ + "static/media/stripe_diners.75ae18fa.svg";